<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Excel template </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="popup">
      <span class="download-btn" (click)="downloadTemplate()">Download Excel Template</span>
      <div class="message">
        <strong>Important:</strong> For this Excel template to work correctly, you may need to
        right-click the downloaded file, select "Properties", and click "Unblock" before opening.
      </div>
      <p>
        Need help? Check out the
        <a
          href="https://support.microsoft.com/en-us/topic/a-potentially-dangerous-macro-has-been-blocked-0952faa0-37e7-4316-b61d-5b5ed6024216"
          target="_blank"
          class="help-link"
          >Microsoft Support Guide</a
        >
        to enable macros.
      </p>
    </div>
  </div>
</div>
